export function getCurrentDate() {
    var date = new Date();
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
};


export function addDaysToCurrentDate(days: number) {
    var date = new Date();
    date.setDate(date.getDate() + days);
    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
}

//only return week days - monday to friday
export function addWeekDaysToCurrentDate(days: number) {
    var date = new Date();
    date.setDate(date.getDate() + days);

    //cater for skipping the weekend
    if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2);
    } else if (date.getDay() === 0) {
        date.setDate(date.getDate() + 1);
    }

    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
}

export function addWeekDaysToDate(dateToModify: string, days: number) {
    var date = new Date(dateToModify);
    date.setDate(date.getDate() + days);

    //cater for skipping the weekend
    if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2);
    } else if (date.getDay() === 0) {
        date.setDate(date.getDate() + 1);
    }

    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
}

export function addDaysToDate(dateToModify: string, days: number) {
    var date = new Date(dateToModify);
    date.setDate(date.getDate() + days);
    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
}

export function addMonthsToDate(dateToModify: string, months: number) {
    var date = new Date(dateToModify);
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() != d) {
        date.setDate(0);
    }

    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    var newDate = date.getFullYear() + "-" + month + "-" + day;
    //we need to remove 1 day from this as our invoice dates are inclusive of start and end dates
    newDate = addDaysToDate(newDate, -1);

    return newDate;
}

export function addBusinessDaysToDate(dateToModify: string, days: number) {
    var date = new Date(dateToModify);
    date.setDate(date.getDate() + days);

    var checkDay = date.getDay();
    if (checkDay === 6) {
        //sat
        date.setDate(date.getDate() + 2);
    } else if (checkDay === 0) {
        //sun
        date.setDate(date.getDate() + 1);
    }

    //format date
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return date.getFullYear() + "-" + month + "-" + day;
}

export function addYeartoCurrentDate(noYears: number) {
    var date = new Date();
    var currentMonth = (date.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = date.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return (date.getFullYear() + noYears) + "-" + month + "-" + day;
}

export function isValidDate(date: any) {
    var timestamp = Date.parse(date);

    if (isNaN(timestamp) == false) {
        return true;
    }
    return false;
}

export function isDateInPast(date: any) {
    var currentdate = new Date();
    currentdate.setHours(0, 0, 0, 0);
    return new Date(date) < currentdate; // true if currentdate is later
}

export function isDateGreater5DaysInPast(date: any) {
    var currentdate = new Date();
    currentdate.setDate(currentdate.getDate() - 5);
    currentdate.setHours(0, 0, 0, 0);
    return new Date(date) < currentdate; // true if currentdate is later
}

export function isDateInFuture(date: any) {
    var currentdate = new Date();
    currentdate.setDate(currentdate.getDate() + 1);
    return new Date(date) > currentdate; // true if currentdate is later
}

export function compareDate(date1: string, date2: string) {
    return new Date(date1) <= new Date(date2); // true if date2 is equal or later
}

export function compareDateGreater(date1: string, date2: string) {
    return new Date(date1) < new Date(date2); // true if date2 is later
}

//if date is between start and end dates return true;
export function dateBetweenDates(date: string, startDate: string, endDate: string) {
    var checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    var checkStartDate = new Date(startDate);
    var checkEndDate = new Date(endDate);

    return checkDate >= checkStartDate && checkDate <= checkEndDate;
}

export function formatDate(date: any) {
    var dateToFormat = new Date(date);
    var currentMonth = (dateToFormat.getMonth() + 1);
    var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    var currentDay = dateToFormat.getDate();
    var day = currentDay < 10 ? "0" + currentDay : currentDay;

    return (day + "/" + month + "/" + dateToFormat.getFullYear());
}

export function daysBetweenDates(dateStart: string, dateEnd: string) {
    var startDate = new Date(dateStart);
    startDate.setHours(0, 0, 0, 0);
    var endDate = new Date(dateEnd);
    endDate.setHours(0, 0, 0, 0);
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    var daysdiff = ((endDate.valueOf() - startDate.valueOf()) / millisecondsPerDay);

    return Math.round(daysdiff);
}

export function validTimeAmount(timeAmount: string) {
    if (timeAmount.length < 4 || timeAmount.length > 5) {
        return false;
    }
    if (!(timeAmount.indexOf(":") == 1 || timeAmount.indexOf(":") == 2)) {
        return false;
    }

    var sHours = timeAmount.split(':')[0];
    var sMinutes = timeAmount.split(':')[1];

    if (sHours == "" || parseInt(sHours) > 24) {
        return false;
    }
    if (sMinutes == "" || parseInt(sMinutes) < 0 || parseInt(sMinutes) > 59) {
        return false;
    }

    return true;
}

export function convertMinsToHoursMinutes(totalMinutes: number) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = Math.round(totalMinutes % 60);
    if (minutes < 10) {
        return hours + ":0" + minutes;
    }

    if (minutes === 60) {
        //add 1 to hour - this happens as I am rounding the minutes
        hours += 1;
        minutes = 0;
        return hours + ":0" + minutes;
    }

    return hours + ":" + minutes;
}

export function convertTimeToMins(timeAmount: string) {
    if (timeAmount.length < 4 || timeAmount.length > 5) {
        return 0;
    }
    if (!(timeAmount.indexOf(":") == 1 || timeAmount.indexOf(":") == 2)) {
        return 0;
    }

    var sHours = timeAmount.split(':')[0];
    var sMinutes = timeAmount.split(':')[1];

    var mins = convertHoursMinutesToMins(parseInt(sHours), parseInt(sMinutes));

    return mins;
}

export function convertHoursMinutesToMins(hours: number, mins: number) {
    var hoursToMins = hours * 60;

    return hoursToMins + mins;
}

export function get1st(month: number, year: number) {
    var newmonth = month < 10 ? "0" + month : month;
    return year + "-" + newmonth + "-01";
}

export function getLastDay(date: Date) {
    var newDate = new Date(date);
    var lastDayOfMonth = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
    return lastDayOfMonth.getDay();
}

export function isDayWeekendDay(date: string) {
    var dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);

    var day = dateToCheck.getDay();
    var isWeekend = (day === 6) || (day === 0);    // 6 = Saturday, 0 = Sunday

    return isWeekend;
}

export function isCurrentDayFriday() {
    var dateToCheck = new Date();
    dateToCheck.setHours(0, 0, 0, 0);

    var day = dateToCheck.getDay();
    var isFriday = (day === 5)

    return isFriday;
}

export function getDayOfWeek(date: string) {
    var dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);

    var day = dateToCheck.getDay();
    
    return day;
}

//get the time difference between two times in minutes\
//this will set date to current date as we are just comparing times
//Note: make sure time is validated before running this function
export function getTimeDifferenceMins(time1: string, time2: string) {
    var startTimeToCheck = new Date();
    var time1Hours = time1.split(':')[0];
    var time1Minutes = time1.split(':')[1];
    startTimeToCheck.setHours(parseInt(time1Hours), parseInt(time1Minutes), 0, 0);

    var endTimeToCheck = new Date();
    var time2Hours = time2.split(':')[0];
    var time2Minutes = time2.split(':')[1];
    endTimeToCheck.setHours(parseInt(time2Hours), parseInt(time2Minutes), 0, 0);

    var timeDifference = Math.abs(endTimeToCheck.valueOf() - startTimeToCheck.valueOf());
    var minutes = Math.floor((timeDifference / 1000) / 60);
    return minutes;
}

//this will set date to current date as we are just comparing times
//Note: make sure time is validated before running this function
export function compareTimeGreater(time1: string, time2: string) {
    var startTimeToCheck = new Date();
    var time1Hours = time1.split(':')[0];
    var time1Minutes = time1.split(':')[1];
    startTimeToCheck.setHours(parseInt(time1Hours), parseInt(time1Minutes), 0, 0);

    var endTimeToCheck = new Date();
    var time2Hours = time2.split(':')[0];
    var time2Minutes = time2.split(':')[1];
    endTimeToCheck.setHours(parseInt(time2Hours), parseInt(time2Minutes), 0, 0);

    return startTimeToCheck < endTimeToCheck;
}

//this will set date to current date as we are just checking times
//Note: make sure time is validated before running this function
export function isTimeInBusinessHours(time: string) {
    //set start time to 6 am
    var startDateTime = new Date();
    startDateTime.setHours(6, 0, 0, 0);

    //set end time to 6:59
    var endDateTime = new Date();
    endDateTime.setHours(18, 59, 0, 0)

    //format time so we can check it
    var timeToCheck = new Date();
    var timeToCheckHours = time.split(':')[0];
    var timeToCheckMinutes = time.split(':')[1];
    timeToCheck.setHours(parseInt(timeToCheckHours), parseInt(timeToCheckMinutes), 0, 0);

    //get times in ticks so can compare
    var timeFinalToCheck = timeToCheck.getTime();
    var startTime = startDateTime.getTime();
    var endTime = endDateTime.getTime();

    //check if passed in datetime is between start and end times
    if (timeFinalToCheck >= startTime && timeFinalToCheck <= endTime) {
        return true;
    }

    return false;
}